export const TREATMENT_PATHWAY_OPTIONS = [
  { value: 58, label: 'Assessment and Advice only' },
  { value: 60, label: 'Assessment Leading to Treatment Denied' },
  { value: 61, label: 'Assessment Leading to Crisis Services' },
  { value: 62, label: 'Assessment Leading to Innapropriate Referral Outcome' },
  { value: 26, label: 'Step 2 - Guided Self-help CBT' },
  { value: 27, label: 'Step 3 - Counselling Remote' },
  { value: 28, label: 'Step 3 - Counselling Face to Face' },
  { value: 29, label: 'Step 3 - CBT Remote' },
  { value: 30, label: 'Step 3 - CBT Face to Face' },
  { value: 69, label: 'Step 3 - Solution Focused Therapy Remote' },
  { value: 32, label: 'Step 4 - Psychiatry Assessment Face to Face' },
  { value: 55, label: 'Step 4 - Psychiatry Follow Up Remote' },
  { value: 56, label: 'Step 4 - Psychiatry Assessment Remote' },
  { value: 57, label: 'Step 4 - Psychiatry Follow Up Face to face' },
  { value: 33, label: 'Step 4 - EMDR Remote' },
  { value: 34, label: 'Step 4 - EMDR Face to Face' },
  { value: 67, label: 'Step 3 - Psycho-Sexual Remote' },
  { value: 68, label: 'Step 3 - Psycho-Sexual Face to face' }
];

export const CYP_TREATMENT_PATHWAY_OPTIONS = [
  { value: 71, label: 'CYP Low Intensity CBT' },
  { value: 72, label: 'CYP Guided Self-help' },
  { value: 73, label: 'CYP CBT Virtual' },
  { value: 74, label: 'CYP CBT Face to Face' },
  { value: 75, label: 'CYP Parent Supported Early Intervention' }
];

export const getTreatmentPathwayOptions = (isCYP) =>
  isCYP
    ? [...TREATMENT_PATHWAY_OPTIONS, ...CYP_TREATMENT_PATHWAY_OPTIONS]
    : TREATMENT_PATHWAY_OPTIONS;
